import { cn } from "cn";
import type { FC } from "react";
import React from "react";

import { Badge } from "@react/ui-primitives/badge";

import type { GithubComment } from "@apis/memory/models";

interface GithubCommentCardProps {
  readonly className?: string;
  readonly comment: GithubComment;
}

export const GithubCommentCard: FC<GithubCommentCardProps> = ({
  className,
  comment,
}) => {
  const isDeleted = comment.githubCommentDeleted;

  return (
    <div className={cn("flex flex-col gap-1 rounded-md border p-3", className)}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">{comment.author}</span>
          {isDeleted && <Badge variant="outline">Deleted on GitHub</Badge>}
        </div>
        <a
          className={`
            text-xs text-muted-foreground
            hover:underline
          `}
          href={comment.url}
          rel="noreferrer"
          target="_blank"
        >
          Pull request #{comment.prNumber}
        </a>
      </div>
      <div className="text-xs text-muted-foreground">{comment.path}</div>
      <div
        className={cn("text-sm whitespace-pre-wrap", {
          "text-muted-foreground": isDeleted,
        })}
      >
        {comment.body}
      </div>
    </div>
  );
};
